import router from '@/router';
import store from '@/store';
import defaultUser from "../defaultUser.json";
export default async (error) => {

    if (error && error.status == 401) {
        localStorage.clear();
        let userInfo = defaultUser[0];
        await store.dispatch('saveAnonymousUser', userInfo);
        router.push("/");
    }
}